import React, { useState } from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { UserSchema } from "../../schema/UserSchema";
import { Col, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import TextError from "../../helpers/FormikHelper/TextError";
import Select from "../../helpers/FormikHelper/Select";
import userServices from "../../services/user.services";
import { toast } from 'react-toastify';
import centerServices from "../../services/center.services";
import { CenterSchema } from "../../schema/CenterSchema";

const initialValues = {
    email: '',
    center_name: '',
    contact_no: '',
    address: '',
    city_id: '',
    state_id: '',
    gst_no:'',
    gst_reg: 'no',
    registration_no: "",


}

const CenterEditForm = ({ toggle, isAddMode, cities, states, getAllCenters, selectedRow }) => {
    const [isActiveGST, setIsActiveGST] = useState(selectedRow?.gst_reg==='yes'?true:false);
    const savedValues = {
        email: selectedRow?.email,
        center_name: selectedRow?.center_name,
        contact_no: selectedRow?.contact_no,
        address: selectedRow?.address,
        city_id: selectedRow?.city_id,
        state_id: selectedRow?.state_id,
        gst_no: selectedRow?.gst_no,
        gst_reg: selectedRow?.gst_reg,
        registration_no: selectedRow?.registration_no

    }
    const onSubmit = async (values) => {
        const reqBody = {
            center_name: values.center_name,
            contact_no: values.contact_no,
            email: values.email,
            user_type_id: 2,
            address: values.address,
            state_id: values.state_id,
            city_id: values.city_id,
            gst_no: values.gst_no,
            gst_reg: values.gst_reg,
            registration_no: values.registration_no
        }
        if (isAddMode === 'Add') {
            const result = await centerServices.createCenter(reqBody);
            if (result.data.status === true) {
                // actions.resetForm();
                getAllCenters()
                toggle()
                toast.success('Record added successfully', { toastId: 'registration_success', autoClose: 3000 });
            } else {
                toast.error(result.data.message, { toastId: 'registration_fail', autoClose: 3000 });
            }
        } else {
            const reqBody = {
                center_name: values.center_name,
                gender: "male",
                contact_no: values.contact_no,
                email: values.email,
                address: values.address,
                state_id: values.state_id,
                city_id: values.city_id,
                gst_no: values.gst_no,
                gst_reg: values.gst_reg,
                registration_no: values.registration_no
            }
            const result = await centerServices.updateCenterById(selectedRow?._id, reqBody)
            if (result.data.status === true) {
                // actions.resetForm();
                getAllCenters()
                toggle()
                toast.success('Record updated successfully', { toastId: 'update_success', autoClose: 3000 });
            } else {
                toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
            }
        }
    }
    return (
        <React.Fragment>
            <Formik
                initialValues={isAddMode === 'Add' ? initialValues : savedValues}
                validationSchema={CenterSchema(isActiveGST===true?"EDIT_CENTER_WITH_GST":"EDIT_CENTER")}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ setFieldValue, values }) => (
                    <Form >
                        <ModalHeader toggle={toggle}>

                            <div className="card-title d-flex align-items-center">
                                <div>
                                    <i className="bx bxs-user me-1 font-22 text-primary" />
                                </div>
                                <h5 className="mb-0 text-primary">{isAddMode === 'Add' ? 'Add Center' : 'Update Center'}</h5>
                            </div>
                        </ModalHeader>
                        <ModalBody className="">
                            <Col md={12}>
                                <div className="row g-3" >
                                    {/* <div className="col-12 mt-0">
                                        <h6 className="center-form-title">Center Info</h6>
                                    </div> */}
                                    <div className="col-md-6 ">
                                        <label htmlFor="center_name" className="form-label">
                                            Center Name
                                        </label>
                                        <Field type="text" className="form-control" id="center_name" name='center_name'
                                        />
                                        <ErrorMessage name='center_name' component={TextError} />
                                    </div>
                                    <div className="col-md-6 ">
                                        <label
                                        htmlFor="registration_no"
                                        className="form-label"
                                        >
                                        Registration No
                                        </label>
                                        <Field
                                        type="text"
                                        className="form-control"
                                        id="registration_no"
                                        name="registration_no"
                                        maxLength="15"
                                        />
                                        <ErrorMessage
                                        name="registration_no"
                                        component={TextError}
                                        />
                                    </div>
                                    <div className="col-md-2">
                            <label htmlFor="" className="me-5 form-label">
                              is GST registered ?
                            </label>
                            <br />

                            <label htmlFor="" className="me-3">
                              Yes
                              <Field
                                type="radio"
                                name="gst_reg"
                                id="yes"
                                value="yes"
                                className="ms-2 form-check-input"
                                onClick={() => setIsActiveGST(true)}
                              />
                            </label>
                            <label htmlFor="female" className="">
                              No
                              <Field
                                type="radio"
                                name="gst_reg"
                                id="no"
                                value="no"
                                className="ms-2 form-check-input"
                                onClick={() => {
                                  setIsActiveGST(false);
                                }}
                              />
                            </label>
                          </div>
                          <div className="col-md-10">
                            {isActiveGST === true ? (
                              <>
                                <label
                                  htmlFor="gst_no"
                                  className="me-5 form-label"
                                >
                                  Enter GST No.
                                </label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  id="gst_no"
                                  name="gst_no"
                                  maxLength={15}
                                />

                                <ErrorMessage
                                  name="gst_no"
                                  component={TextError}
                                />
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                                    <div className="col-md-6">
                                        <label htmlFor="email" className="form-label">
                                            E-Mail
                                        </label>
                                        <Field type="email" className="form-control" id="email" name='email'
                                        />
                                        <ErrorMessage name='email' component={TextError} />
                                    </div>
                                    <div className="col-md-6 ">
                                        <label htmlFor="contact_no" className="form-label">
                                            Contact No
                                        </label>
                                        <Field type="text" className="form-control" id="contact_no" name='contact_no'  maxLength="10"
                                        />
                                        <ErrorMessage name='contact_no' component={TextError} />
                                    </div>
                                    <div className="col-12 ">
                                        <label htmlFor="address" className="form-label">
                                            Address
                                        </label>
                                        <Field
                                            className="form-control"
                                            id="address"
                                            // placeholder="Address..."
                                            name='address'
                                            type='text'
                                        />
                                        <ErrorMessage name="address" component={TextError} />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="state_id" className="form-label">
                                            State
                                        </label>
                                        <Field as='select' className='form-select' id="state_id" name="state_id" >
                                            <option disabled value="">Select State</option>
                                            {
                                                states.map((e, key) => {
                                                    return <option key={key} value={e.state_id}>{e.state_name}</option>;
                                                })
                                            }
                                        </Field>
                                        <ErrorMessage name="state_id" component={TextError} />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="city_id" className="form-label"> City </label>
                                        <Field as='select' className='form-select' id="city_id" name="city_id"
                                        // onChange={e => {
                                        //     // call the built-in handleBur
                                        //     handleBlur(e)
                                        //     // and do something about e
                                        //     let someValue = e.currentTarget.value
                                        //     console.log('someValue', someValue)
                                        //     setFieldValue("city", someValue);
                                        //     // ...
                                        // }}
                                        >
                                            <option disabled value="">Select city</option>
                                            {
                                                cities.map((e, key) => {
                                                    if (e.state_id === values.state_id) {
                                                        return <option key={key} value={e.city_id}>{e.city_name}</option>;
                                                    }
                                                })
                                            }
                                        </Field>
                                        <ErrorMessage name="city_id" component={TextError} />
                                    </div>
                               
                                   
                                </div>
                            </Col>
                        </ModalBody>
                        <ModalFooter>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={toggle}
                            >
                                Close
                            </button>
                            <button type="submit" className="btn btn-primary px-5">
                                {isAddMode === "Add" ? "Save" : "Update"}
                            </button>
                        </ModalFooter>
                    </Form>
                )}
            </Formik>
        </React.Fragment>
    );
}

export default CenterEditForm;